import RegisterPersonalDataError from './RegisterPersonalDataError';
class InvalidBirthCountry extends RegisterPersonalDataError {
    constructor(birthCountry, options) {
        super(`Can not register birth country: ${birthCountry}`, options);
    }
}
export default InvalidBirthCountry;
